import { Component, inject, OnInit, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogAction } from '../../dialog-action';
import { DialogData as DialogContext } from '../../dialog-data';
import { DashboardDialogFramePart } from '../../dialog-frame/dialog-frame.part';


@Component({
	selector: 'dashboard-message-dialog',
	standalone: true,
	imports: [
		DashboardDialogFramePart,
	],
	templateUrl: './message.dialog.html',
	styleUrls: ['./message.dialog.scss']
})
export class MessageDialog implements OnInit {

	message: string = '';
	bullets: string[] = [];
	header = 'Message';
	translateMessage = false;

	closeText = signal('Okay');

	closeAction: DialogAction = {
		id: 'close',
		cssClass: signal(undefined),
		enabled: signal(true),
		visible: signal(true),
		text: this.closeText,
		linkType: "no-action",
		willCloseDialog: true,
	};

	actions: DialogAction[] = [this.closeAction];
	public dialog: DialogContext<{ header: string, message: string, buttonText?: string, bullets: string[] }> = inject(MAT_DIALOG_DATA);

	constructor(
		public dialogRef: MatDialogRef<MessageDialog>,
	) {
	}

	async ngOnInit() {

		if (this.dialog.data) {
			this.header = this.dialog.data.header || 'Message';
			this.message = this.dialog.data.message || '';
			this.bullets = this.dialog.data.bullets;
		}
		this.translateMessage = typeof this.message !== 'string';
		this.closeText.set(this.dialog.data?.buttonText ?? 'Okay');
	}

}